import { Search } from 'lucide-react';
import type { SalesTeam } from '../../types/salesTeamConfig';

interface SalesTeamConfigFiltersProps {
    searchTerm: string;
    selectedTeamId: number | null;
    selectedCompanyCode: string | null;
    teams: SalesTeam[];
    companyCodes: string[];
    onSearchChange: (term: string) => void;
    onTeamChange: (teamId: number | null) => void;
    onCompanyChange: (code: string | null) => void;
}

export function SalesTeamConfigFilters({
    searchTerm,
    selectedTeamId,
    selectedCompanyCode,
    teams,
    companyCodes,
    onSearchChange,
    onTeamChange,
    onCompanyChange,
}: SalesTeamConfigFiltersProps) {
    return (
        <div className="flex flex-wrap gap-3">
            {/* Search */}
            <div className="relative flex-1 min-w-[200px]">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                <input
                    type="text"
                    placeholder="Search by name, code, or email..."
                    value={searchTerm}
                    onChange={e => onSearchChange(e.target.value)}
                    className="w-full rounded-md border border-gray-300 py-2 pl-9 pr-3 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
            </div>

            {/* Team filter */}
            <select
                value={selectedTeamId ?? ''}
                onChange={e => onTeamChange(e.target.value ? Number(e.target.value) : null)}
                className="rounded-md border border-gray-300 py-2 px-3 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
                <option value="">All Teams</option>
                {teams.map(t => (
                    <option key={t.SalesTeamID} value={t.SalesTeamID}>
                        {t.SalesTeamName}
                    </option>
                ))}
            </select>

            {/* Company code filter */}
            <select
                value={selectedCompanyCode ?? ''}
                onChange={e => onCompanyChange(e.target.value || null)}
                className="rounded-md border border-gray-300 py-2 px-3 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
                <option value="">All Companies</option>
                {companyCodes.map(c => (
                    <option key={c} value={c}>
                        {c.toUpperCase()}
                    </option>
                ))}
            </select>
        </div>
    );
}
